import { createUseStyles } from "react-jss";
export const RepresentativeStyle = createUseStyles((theme: any) => ({
    validate: {
        color: theme.colors.font.success,
    },
    pending: {
        color: theme.colors.font.warning,
    },
}));
